import logo from './logo.svg';
import './App.css';
import {Routes,Route} from 'react-router-dom'
import Home from './Pages/Home';
import Home_gamebox from './Pages/Home_gamebox';
import AdminDashboard from './Pages/AdminDashboard';
import 'primereact/resources/themes/lara-light-blue/theme.css'; // Theme  
import 'primereact/resources/primereact.min.css'; // Core CSS  
import 'primeicons/primeicons.css'; // Icons  
// import 'primeflex/primeflex.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import About from './Pages/About';
import HowToPlay from './Pages/HowToPlay';
import About_gamebox from './Pages/About_gamebox';
import HowToPlay_gamebox from './Pages/HowToPlay_gamebox';
import Tnc_gamebox from './Pages/Tnc_gamebox';
import Tnc from './Pages/Tnc';
import InstantAbout from './Pages/InstantAbout';


function App() {
  return (
    <>
      <Routes>
      <Route path='/' element={<About/>} />
      <Route path='/admin/dashboard' element={<AdminDashboard/>} />
      <Route path='/football-quiz' element={<About/>} />
      <Route path='/football-quiz/play' element={<HowToPlay/>} />
      <Route path='/football-quiz/terms' element={<Tnc/>} />
      <Route path='/instant-game' element={<InstantAbout/>} />
  <Route path='/game-box' element={<About_gamebox/>} />
      <Route path='/game-box/play' element={<HowToPlay_gamebox/>} />
      <Route path='/game-box/terms' element={<Tnc_gamebox/>} />
      </Routes>
      <ToastContainer/>
    </>
  );
}

export default App;
